import { AuditAudio } from '@mi-front/core';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import React from 'react';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../api';
import { RowActionMui, RowActionMuiProps } from '../../../../../components/table/RowActionMui';
import { useUrlMediaPlayerCtx } from '../../../../../core/media-player/useUrlMediaPlayer';
import { mimeType } from '../../../../../helpers/utils';

export function AuditMediaPlayerAction({
  audio,
  ActionComponent = RowActionMui,
}: {
  audio: Pick<AuditAudio, 'stationId' | 'customId' | 'filename'>;
  ActionComponent?: React.ComponentType<RowActionMuiProps>;
}) {
  const ctx = useUrlMediaPlayerCtx();
  const { $t } = useIntl();

  return (
    <ActionComponent
      title={$t({
        id: 'audit.mediaPlayer.viewMedia',
        defaultMessage: 'Reproducir media',
      })}
      color="primary"
      onClick={() => {
        const url = apiClient.audit.getDownloadAudioUrl({
          stationId: audio.stationId!,
          customId: audio.customId,
        });

        ctx.play(url, {
          title: audio.customId,
          type: mimeType(audio.filename),
        });
      }}
    >
      <PlayCircleOutlineRoundedIcon />
    </ActionComponent>
  );
}
